<script lang="ts">
      import { getCachedAsset } from '$lib/utils/cache'
      import { onMount } from 'svelte'
      import VideoControl from './VideoControl.svelte'
      import type { HTMLVideoElementEvents, VideoStats } from './ts/VideoElement.svelte'

      const event = ['load', 'ended', 'error', 'playing', 'loadeddata', 'loadstart', 'complete', 'canplaythrough', 'seeked', 'seeking', 'canplay', 'timeupdate', 'pause']

      const statusEvents = ['ended', 'playing', 'seeking', 'seeked', 'canplaythrough', 'pause', 'timeupdate']

      async function handleEvent(e: Event) {
            //if (e.type == 'canplaythrough' && autoplay) play()
            //if (e.type == 'ended' && loop) seekToStart()

            const target = e.target as HTMLVideoElement | undefined
            if (!target) return


            let update: { [keyof: string]: any } = {}

            if( e.type == "seeking" ) {
              //console.log(target)
              //target.pause()
            }

            if( e.type == "seeked" ) {
              //target.play()
            }

            if (e.type == 'loadstart') {
                  update = { playing: false, ended: false, currentTime: -1, canPlayThrough: false, canPlay: false, seeking: false, muted: false }
            }

            if (e.type == 'loadeddata') {
                  update.length = target.duration
            }

            if (e.type == 'playing') {
                  update.currentTime = target.currentTime
                  update.playing = true
            }

            if (e.type == 'pause') {
                  update.currentTime = target.currentTime
                  update.playing = false
            }
            if (e.type == 'timeupdate') {
                  update.currentTime = target.currentTime
                  update.muted = target.muted
            }

            if (e.type == 'canplaythrough') {
                  update.currentTime = target.currentTime
                  update.canPlayThrough = true
            }

            if (e.type == 'canplay') {
                  update.currentTime = target.currentTime
                  update.canPlay = true
            }

            stats = { ...stats, ...update, lastEvent: e.type as HTMLVideoElementEvents }
      }

      async function cacheVideo(url: string) {
            const response = await getCachedAsset(url)
            const blob = await response.blob()
            const urlObject = URL.createObjectURL(blob)
            return urlObject
      }

      export async function loadAsync() {
            if (!videoElement) return
            videoElement.pause()

            const ctrl = new AbortController()

            let _url = video.url
            if (cache) {
                  _url = await cacheVideo(_url)
            }

            if( ! videoElement ) return

            videoElement.src = _url

            videoElement.load()

            return new Promise((resolve, reject) => {
                  videoElement.addEventListener(
                        'canplay',
                        () => {
                              resolve(true)
                              ctrl.abort()
                        },
                        { signal: ctrl.signal }
                  )
                  videoElement.currentTime = 0
            })
      }

      export async function playAsync() {
            if (!videoElement) return
            videoElement.pause()

            const ctrl = new AbortController()

            return new Promise((resolve, reject) => {
                  videoElement.addEventListener(
                        'ended',
                        () => {
                              resolve(true)
                              ctrl.abort()
                        },
                        { signal: ctrl.signal }
                  )
                  videoElement.play()
            })
      }

      async function updateStatus(e: Event) {
            status = e.type
      }

      export function play() {
            console.log(paused)
            if (paused === undefined) return
            if (paused) return videoElement.play()
            return videoElement.pause()
      }

      async function playVideo() {
            await loadAsync()
            await playAsync()

            if (loop) return playVideo()
      }

      function seekToStart() {
            videoElement.currentTime = 0
      }

      export function getElement() {
            return videoElement
      }

      export function isPlaying() {
            return videoElement.paused
      }

      let abort: AbortController
      onMount(() => {
            videoElement.pause()
            if (muted || autoplay) {
                  videoElement.muted = true
                  videoElement.setAttribute('muted', `true`)
            }
            abort = new AbortController()

            event.map((e) => {
                  videoElement.addEventListener(e, handleEvent, { signal: abort.signal })
            })

            statusEvents.map((e) => {
                  videoElement.addEventListener(e, updateStatus, { signal: abort.signal })
            })

            if (autoplay) playVideo()
            else loadAsync()

            return () => abort.abort()
      })

      let { video = {}, loop = false, autoplay = false, status = $bindable(), cache = false, muted = true, class: className = '' } = $props()

      status = 'init'

      $effect(() => {
            //console.log(stats)
      })

      let stats: VideoStats = $state({
            playing: false,
            ended: false,
            currentTime: -1,
            length: -1,
            canPlayThrough: false,
            canPlay: false,
            seeking: false,
            lastEvent: undefined,
            muted: false
      })

      let videoElement: HTMLVideoElement
      let paused: boolean | null | undefined = $state(undefined)
      let _videoUrl = ''
      //let canplaythrough: boolean = $state(false)
</script>

<div class="relative {className} bg-black flex justify-center items-center">
      <!-- svelte-ignore a11y_media_has_caption -->
      <video src={_videoUrl} bind:paused bind:this={videoElement} class="w-full h-auto" disablePictureInPicture={true} playsinline></video>
      <VideoControl bind:element={videoElement} {stats}></VideoControl>
</div>

<style lang="postcss">
</style>
